<template>
  <div class="b-accordion b-accordion--card">
    <h3 class="b-accordion__head">{{ item.head }}</h3>

    <div class="b-accordion__conts">
      <div class="b-accordion__conts__inner">
        <article>
          <div class="s-net-price__slider">
            <div class="s-net-price__items swiper">
              <div class="swiper-wrapper">
                <div
                  v-for="i in item.row"
                  :key="i.id"
                  class="s-net-price__item swiper-slide">
                  <div class="b-data-card">
                    <div class="b-data-card__title" v-html="i.cell[0] "></div>
                    <div class="b-data-card__data">
                      <div
                        v-for="(cell, index) in i.cell.slice(
                          1,
                          i.cell.length
                        )"
                        :key="index"
                        class="b-data-card__data__item" v-html="cell">
                       
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="swiper-pagination" style="--timer: 4"></div>
          </div>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    item: {
      required: true,
      type: Object,
    },
  },
}
</script>
